import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from 'src/app/dialog.component';
import { sessionStorage } from 'src/app/localstorage.service';
import * as moment from 'moment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-dr-complaint-add',
    templateUrl: './dr-complaint-add.component.html',
    styleUrls: ['./dr-complaint-add.component.scss']
})
export class DrComplaintAddComponent implements OnInit {
    data:any={}
    dr_id:any;
    dr_detail: any;
    total_qty: any = 0;
    states: any = [];
    district_list: any = [];
    items:any=[];
    categoryList:any=[];
    product_list:any=[];
    add_list:any=[]
    product_resp: boolean;
    nexturl:any;
    product_detail: any = {};
    natureOfComplaintData: any = [];
    brandList: any = [];
    addressData: any = [];
    colorList: any = [];
    temp_add_list: any = [];
    addToListButton: boolean = true;
    savingFlag: boolean = false;
    user_data:any={};
    SpecialDiscountLable:any=''
    login_data: any = {};
    loader:boolean=false;
    myDate: Date;
    selected_image: any = [];
    item_wise_image: any = [];
    assignedSalesUser: any = [];
    errorMsg: boolean = false;
    image_id: any;
    image = new FormData();
    
    
    constructor(public serve: DatabaseService,public route: ActivatedRoute, public toast: ToastrManager,public dialog: DialogComponent,private router: Router,public session: sessionStorage, private sanitizer: DomSanitizer) {
        this.login_data = this.session.getSession();
        this.login_data = this.login_data.value;
        this.login_data = this.login_data.data;
        console.log(`this.login_data`, this.login_data);
        this.myDate = new Date();
    }
    
    ngOnInit() {
        this.route.params.subscribe(params => {
            console.log(params);
            this.dr_id = params.id;
            console.log(this.dr_id);
            this.distributorDetail()
            this.getStateList();
            this.getNatureOfComplaint();
            this.getAssignedSalesUser();
            this.data.total_coupon='Abcd qwwewe wewe'
        })
    }

    getSanitizedUrl(url: string): SafeUrl {
        return this.sanitizer.bypassSecurityTrustUrl(url);
      }
    
    MobileNumber(event: any) {
        const pattern = /[0-9\+\-\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }
    }
    
    getStateList() {
        this.serve.post_rqst(0, "CustomerNetwork/getAllState").subscribe((response => {
            if (response['statusCode'] == 200) {
                this.states = response['all_state'];
            } else {
                this.toast.errorToastr(response['statusMsg']);
            }
        }));
    }
    getAssignedSalesUser() {
        this.serve.post_rqst({"id": this.dr_id}, "Support/salesUserAssignListing").subscribe((response => {
            console.log(response);
            
            if (response['statusCode'] == 200) {
                this.data.sales_head = response['result']['id'];
                this.data.sales_head_name = response['result']['name'];
            } else {
                this.toast.errorToastr(response['statusMsg']);
            }
        }));
    }
    
    
    
    getDistrict(states) {
        console.log(states);
        
        this.serve.post_rqst({ 'state_name': states }, "CustomerNetwork/getAllDistrict").subscribe((response => {
            if (response['statusCode'] == 200) {
                
                this.district_list = response['all_district'];
            } else {
                this.toast.errorToastr(response['statusMsg']);
            }
        }));
    }
    
    get_address(pincode) {
        console.log(pincode,'pincode')
        this.serve.post_rqst({ 'pincode':pincode}, 'Support/getPostalInfo').subscribe((result) => {
            if (result['statusCode'] == 200) {
                console.log(result)
                this.addressData = result['result'];
                this.data.state = this.addressData.state_name;
                this.getDistrict(this.data.state);
                this.data.district = this.addressData.district_name;
                this.data.city = this.addressData.city;
                console.log(this.data.state , this.data.district , this.data.city);
                
            }
        });
    }
    
    distributorDetail() {
        
        this.loader=true
        let id = { "id": this.dr_id }
        this.serve.post_rqst(id, "CustomerNetwork/distributorDetail").subscribe((result) => {
            if (result['statusCode'] == 200) {
                this.loader=false
                this.dr_detail = result['distributor_detail'];
                this.getCategory('');
                // this.getitem('',this.dr_detail.brand)
            } else {
                this.loader=true
                this.toast.errorToastr(result['statusMsg'])
            }
            
        })
    }
    
    getNatureOfComplaint() {
        
        this.loader=true
        this.serve.post_rqst({}, "Support/natureOfComplaint").subscribe((result) => {
            if (result['statusCode'] == 200) {
                this.loader=false
                this.natureOfComplaintData = result['result'];
            } else {
                this.loader=true
                this.toast.errorToastr(result['statusMsg'])
            }
            
        })
    }
    
    getCategory(search){
        this.loader=true
        this.serve.post_rqst({'filter':{'search':search}}, "Order/getProductCategory")
        .subscribe(resp => {
            console.log(resp);
            
            if (resp['statusCode'] == 200) {
                this.loader=false
                this.categoryList = resp['result'];
                console.log(this.categoryList);
                
            } else {
                this.loader=false
                this.toast.errorToastr(resp['statusMsg'])
            }
        })
    }
    
    getitem(search){
        this.loader=true
        this.serve.post_rqst({'filter':{'category_id': this.data.category_id,'search':search}}, "Order/segmentItems")
        .subscribe(resp => {
            console.log(resp);
            
            if (resp['statusCode'] == 200) {
                this.loader=false
                this.items = resp['result'];
                console.log(this.items);
                
            } else {
                this.loader=false
                this.toast.errorToastr(resp['statusMsg'])
            }
        })
    }
    
    get_product_details(id) {
        this.data.brand = '';
        this.data.color = '';
        this.loader=true
        this.serve.post_rqst({ 'product_id': id, 'order_type': 'primary', 'brand': this.dr_detail.brand }, "Order/segmentItemsDetails")
        .subscribe(resp => {
            
            if (resp['statusCode'] == 200) {
                this.loader=false
                this.product_detail = resp['result'];
                this.brandList = this.product_detail['brand'];
                this.colorList = this.product_detail['color'];
                if (this.brandList.length == 1) {
                    this.data.brand = this.brandList[0];
                }
                if (this.colorList.length == 1) {
                    this.data.color = this.colorList[0];
                }
                
            } else {
                this.toast.errorToastr(resp['statusMsg'])
                this.loader=false
            }
        })
    }
    gst:any;
    get_product_Size(dr_id, product_id) {
        let Feature_Api = ""
        let Index = this.items.findIndex(row => row.id == product_id)
        if (Index != -1) {
            this.data.product_name = this.items[Index].product_name
            this.data.feature_apply = this.items[Index].feature_apply
            this.data.product_code = this.items[Index].product_code
            this.gst=this.items[Index].gst
        }
        this.loader=true
        console.log(this.product_detail.category_id)
        console.log(this.product_detail)
        setTimeout(() => {
            this.serve.post_rqst({ 'state_name': this.dr_detail.state, 'dr_id': dr_id, 'category_id': this.product_detail.category_id, 'gst_percent': this.gst, 'product_id':product_id }, "Order/segmentItemPriceWithoutFeatures")
            .subscribe(resp => {
                if (resp['statusCode'] == 200) {
                    this.loader=false
                    this.product_resp = true
                    this.product_list = resp['result'];
                    
                    if (this.product_list.length > 0) {
                        for (let i = 0; i < this.product_list.length; i++) {
                            this.product_list[i].edit_true = false;
                        }
                    }
                } else {
                    this.toast.errorToastr(resp['statusMsg'])
                    this.product_resp = false
                    this.loader=false
                }
            },
            err => {
            })
        }, 200);
    }
    
    addToList() {
        
        for (let i = 0; i < this.product_list.length; i++) {
            if (this.product_list[i]['qty']) {
                let existIndex
                existIndex = this.add_list.findIndex(row => row.product_id == this.product_list[i]['product_id'] && row.brand == this.data.brand && row.color == this.data.color);
                if (existIndex == -1) {
                    this.product_list[i]['product_name'] = this.data.product_name;
                    this.product_list[i]['brand'] = this.data.brand;
                    this.product_list[i]['color'] = this.data.color;
                    this.product_list[i]['segment_id'] = this.product_detail.category_id;
                    this.product_list[i]['segment_name'] = this.product_detail.category;
                    this.product_list[i]['nature_of_complaint'] = this.product_detail.nature_of_complaint;
                    this.product_list[i]['item_wise_image'] = this.item_wise_image;
                    this.product_list[i]['product_code'] = this.data.product_code;
                    this.add_list.push(this.product_list[i]);
                    this.temp_add_list.push(this.product_list[i])
                }
                else {
                    this.product_list[i]['product_name'] = this.data.product_name;
                    this.product_list[i]['segment_id'] = this.product_detail.category_id;
                    this.product_list[i]['segment_name'] = this.product_detail.category;
                    this.product_list[i]['nature_of_complaint'] = this.product_detail.nature_of_complaint;
                    this.product_list[i]['item_wise_image'] = this.item_wise_image;
                    this.product_list[i]['product_code'] = this.data.product_code;
                    this.add_list[existIndex]['qty'] = parseInt(this.add_list[existIndex]['qty']) + parseInt(this.product_list[i]['qty']);
                }
            }
            
        }
        
        this.total_qty = 0;
        
        for (let i = 0; i < this.add_list.length; i++) {
            this.total_qty = (parseInt(this.total_qty) + parseInt(this.add_list[i]['qty']));
        }
        
        this.product_list = [];
        this.data.brand = '';
        this.data.color = '';
        this.data.category_id = '';
        this.data.product_id = '';
        this.item_wise_image = [];
        this.addToListButton = true;
        console.log(this.add_list);
        
    }
    
    
    
    listdelete(i) {
        this.add_list.splice(i, 1);
        this.total_qty = 0;
        console.log(this.add_list);
        for (let i = 0; i < this.add_list.length; i++) {
            this.total_qty = (parseInt(this.total_qty) + parseInt(this.add_list[i]['qty']));
        }
    }
    
    saveComplaintAlert() {
        this.dialog.confirm("You want to submit this Complaint ?").then((result) => {
            if (result) {
                this.saveComplaint()
            }
        })
    }
    
    // add image 
    onUploadChange(data: any) {
        this.errorMsg = false;
        this.image_id = '';
        for (let i = 0; i < data.target.files.length; i++) {
            let files = data.target.files[i];
            if (files) {
                let reader = new FileReader();
                reader.onload = (e: any) => {
                    this.selected_image.push({ "image": e.target.result });
                }
                reader.readAsDataURL(files);
            }
            this.image.append("" + i, data.target.files[i], data.target.files[i].name);
        }
    }
    
    onItemWiseUploadImage(data: any) {
        this.errorMsg = false;
        this.image_id = '';
        for (let i = 0; i < data.target.files.length; i++) {
            let files = data.target.files[i];
            if (files) {
                let reader = new FileReader();
                reader.onload = (e: any) => {
                    this.item_wise_image.push({ "image": e.target.result });
                }
                reader.readAsDataURL(files);
            }
            this.image.append("" + i, data.target.files[i], data.target.files[i].name);
        }
    }
    
    deleteItemWiseImage(arrayIndex) {
        this.item_wise_image.splice(arrayIndex, 1);
    }
    
    saveComplaint() {
        this.savingFlag = true;
        // this.data.image = this.selected_image ? this.selected_image : [];
        this.data.type = '1';
        this.data.dr_id = this.dr_id
        this.data.dr_name = this.login_data.company_name
        console.log(this.data);
        if (this.data.issue_date) {
            
            this.data.issue_date = moment(this.data.issue_date).format('YYYY-MM-DD');
        }
        
        this.serve.post_rqst({ "add_list": this.add_list, 'data': this.data}, "Support/submitComplain").subscribe(resp => {
            if (resp['statusCode'] == 200) {
                var toastString = ''
                if (this.user_data.order_status == 'Draft') {
                    this.dialog.success('',resp['statusMsg'])
                }
                else {
                    this.dialog.success('',resp['statusMsg'])
                }
                
                this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/distribution-list/1/Channel%20Partner/distribution-detail/'+this.login_data['id']+'/'+'DrComplaint';
                this.router.navigate([this.nexturl]);
                
            } else {
                this.dialog.error(resp['statusMsg']);
            }
        },
        error => {
        })
    }
    
    // submit() {
    //     // if (this.data.small_packing_size == '1') {
    //     //   this.toast.errorToastr('Small Packing Size should not be 1');
    //     //   return;
    //     // }
    //     this.data.image = this.selected_image ? this.selected_image : [];
    //     this.savingFlag = true;
    //     let header
    //     if (this.product_id) {
    //         this.data.last_updated_by_name = this.userName;
    //         this.data.last_updated_by = this.userId;
    //         header = this.service.post_rqst({ 'data': this.data }, "Master/updateProduct")
    //     }
    //     else {
    //         this.data.created_by_name = this.userName;
    //         this.data.created_by = this.userId;
    //         header = this.service.post_rqst({ 'data': this.data }, "Master/addProduct")
    //     }
    //     header.subscribe((result) => {
    //         if (result['statusCode'] == 200) {
    //             this.rout.navigate(['/product-list']);
    //             this.toast.successToastr(result['statusMsg']);
    //         }
    //         else {
    //             this.toast.errorToastr(result['statusMsg']);
    //             this.savingFlag = false;
    //         }
    //     }, err => {
    //         this.savingFlag = false;
    //     })
    // }
    
    back(){
        this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/distribution-list/1/Channel%20Partner/distribution-detail/'+this.login_data['id']+'/'+'DrComplaint';
        // this.router.navigate(['/distribution-list'])
        this.router.navigate([this.nexturl]);
        
    }
    
    // getInfo(id) {
    //     let index = this.users.findIndex(row => row.id == id)
    //     if (index != -1) {
    //         this.data.name = this.users[index].name;
    //         this.data.user_type = this.users[index].user_type;
    //     }
    // }
}
